<div class="sfl" id="sflWrapper">
    <div class="list-search-container mb-2">
        <i class="fas fa-search list-search-icon ml-0"></i>
        <input type="text"
            (click)="$event.stopPropagation()"
            (input)="searchInFields($event.target.value)"
            [(ngModel)]="filterText"
            placeholder="{{ 'Search' | translate }}"
            class="form-control list-search-input flex-grow-1 pl-2">
        <i *ngIf="filterText"
            (click)="clearFilter()"
            class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon"
            aria-hidden="true"
            ></i>
    </div>
    <div *ngIf="showFields" class="p-0 mb-2">
        <div class="p-0">
            <h5 class="mb-0">
                <button class="btn btn-block sfl-panel-toggler collapsed {{loadingFields ? 'preload': ''}} no-drag" data-toggle="collapse" data-target="#allFields">
                    {{"All Forms Fields" | translate}}
                </button>
            </h5>
        </div>
        <div class="panel-collapse collapse" id="allFields" data-parent="#sflWrapper">
            <div class="card-body panel-body no-drop p-0">
                <!--
                <div class="sfl-search">
                    <input class="w-100 form-control form-control-sm" (input)="searchInFields($event.target.value)">
                    <i *ngIf="!searchStringFormatted || searchStringFormatted.length < 1" class="fad fa-search"></i>
                    <i *ngIf="searchStringFormatted && searchStringFormatted.length > 0" (click)="searchStringFormatted = ''" class="fad fa-times text-danger"></i>
                </div>
                -->
                <div class="sfl-items">
                    <ng-container *ngFor="let item of fields">
                        <sfl-item *ngIf="!item.isgroup || (item.isgroup && item.items.length > 0)" [item]="item"></sfl-item>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showCatalogs" class="p-0 mb-2">
        <div class="p-0">
            <h5 class="mb-0">
                <button class="btn btn-block sfl-panel-toggler collapsed {{loadingCatalogs ? 'preload': ''}} no-drag" data-toggle="collapse" data-target="#allCatalogs">
                    {{"Catalogs" | translate}}
                </button>
            </h5>
        </div>
        <div class="panel-collapse collapse" id="allCatalogs" data-parent="#sflWrapper">
            <div class="card-body panel-body no-drop p-0">
                <!--
                <div class="sfl-search">
                    <input class="w-100 form-control form-control-sm" [(ngModel)]="searchCatalogs">
                    <i *ngIf="!searchCatalogs || searchCatalogs.length < 1" class="fad fa-search"></i>
                    <i *ngIf="searchCatalogs && searchCatalogs.length > 0" (click)="searchCatalogs = ''" class="fad fa-times text-danger"></i>
                </div>
                -->
                <div class="sfl-items">
                    <ng-container *ngFor="let item of allCatalogs | labelFilter: searchCatalogs">
                        <sfl-item [item]="item"></sfl-item>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div *ngIf="showTags" class="p-0 m-0">
        <div class="p-0">
            <h5 class="mb-0">
                <button class="btn btn-block sfl-panel-toggler collapsed {{loadingTags ? 'preload': ''}} no-drag" data-toggle="collapse" data-target="#allTags">
                    {{"System Tags" | translate}}
                </button>
            </h5>
        </div>
        <div class="panel-collapse collapse" id="allTags" data-parent="#sflWrapper">
            <div class="card-body panel-body no-drop p-0">
                <!--
                <div class="sfl-search">
                    <input class="w-100 form-control form-control-sm" [(ngModel)]="searchTags">
                    <i *ngIf="!searchTags || searchTags.length < 1" class="fad fa-search"></i>
                    <i *ngIf="searchTags && searchTags.length > 0" (click)="searchTags = ''" class="fad fa-times text-danger"></i>
                </div>
                -->
                <div class="sfl-items">
                    <ng-container *ngFor="let item of allTags | labelFilter: searchTags">
                        <sfl-item [item]="item"></sfl-item>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>